import { colors } from "components/Theme/WebTheme.js";
import { container } from "./material-kit-react.js"

const footerStyle = {
  block: {
    color: colors.Button_Primary,
    padding: "0.9375rem",
    fontWeight: "600",
    fontSize: "13px",
    textTransform: "uppercase",
    borderRadius: "3px",
    textDecoration: "none",
    position: "relative",
    display: "block",
    textAlign: "center"
  },
  left: {
    float: "left!important",
    display: "block"
  },
  right: {
    margin: "0",
    float: "right!important"
  },
  footer: {
    padding: "0.9375rem 0",
    textAlign: "center",
    display: "flex",
    zIndex: "2",
    position: "relative",
    color: colors.Button_Primary,
    flexDirection: "column",
    alignItems: "center"
  },
  a: {
  color: colors.Button_Primary,
    textDecoration: "none",
    backgroundColor: "transparent"
  },
  footerWhiteFont: {
    "&,&:hover,&:focus": {
      color: colors.WHITE
    }
  },
  container,
  list: {
    marginBottom: "0",
    padding: "0",
    marginTop: "0"
  },
  inlineBlock: {
    display: "inline-block",
    padding: "0px",
    width: "auto"
  },
  icon: {
    width: "18px",
    height: "18px",
    position: "relative",
    top: "3px"
  }
};
export default footerStyle;
